<template>
  <div id="claim-template-new" v-if="hasPrivilege">
    <vs-row style="flex-wrap: wrap-reverse">
      <vs-col vs-lg="9" vs-sm="12">
        <div class="flex flex-col gap-4" v-if="hasClaimType">
          <div class="claim-template-new-title font-bold">
            {{ claimTemplateTitle }}
          </div>
          <claim-type-form
            :initialClaimType="claimType"
            :onClickCreate="() => {}"
            :claimItems="claimItems"
          ></claim-type-form>
        </div>
      </vs-col>
      <vs-col class="right-widget-area" vs-lg="3" vs-sm="12">
        <hull-navigation-select
          class="my-4"
          menuButtonLabel="メニュー"
          :menuItemOptions="getMenuItemOptions(this.$route.name)"
        >
        </hull-navigation-select>
      </vs-col>
    </vs-row>
  </div>
  <div
    v-else-if="enterpriseKind == 1"
    :class="{ 'pointer-events-none': !isEditable }"
  >
    <no-access-label></no-access-label>
  </div>
</template>

<script>
import HullNavigationSelect from "../components/molecules/HullNavigationSelect.vue";
import ClaimTypeForm from "./ClaimTypeForm.vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import isObject from "lodash/isObject";
import isNull from "lodash/isNull";
import NoAccessLabel from "../components/organisms/NoAccessLabel.vue";
const claimTypeRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseClaimType"
);
const claimItemRepository = AiseaApiFactory.get(
  "hullInsuranceEnterpriseClaimItem"
);
import { HullInsranceMixin } from "@/mixins";
import claimTemplateService from "@/services/claimTemplateService";
const ClaimType = claimTemplateService.getClaimTypeClass();
const ClaimItem = claimTemplateService.getClaimItemClass();

export default {
  name: "T.ClaimTemplate",
  mixins: [HullInsranceMixin],
  components: {
    HullNavigationSelect,
    ClaimTypeForm,
    NoAccessLabel,
  },
  data() {
    return {
      claimType: null,
      claimItems: [],
      enterpriseKind: null,
    };
  },
  computed: {
    claimTemplateTitle() {
      if (!isObject(this.claimType)) return "";
      return this.claimType.name || "";
    },
    claimTypeId() {
      return this.$route.params.id;
    },
    isEditable() {
      return [1, 2, 3].includes(this.claimTypeStatus);
    },
    hasClaimType() {
      return !isNull(this.claimType);
    },
    claimTypeStatus() {
      if (!this.hasClaimType) return null;
      return this.claimType.status;
    },
    hasPrivilege() {
      return this.enterpriseKind === 2;
    },
  },
  methods: {
    async setUp() {
      this.enterpriseKind = await this.getEnterpriseKind();
      if (!this.hasPrivilege) return;

      this.setClaimType(this.claimTypeId);
      this.setClaimItems();
    },
    async setClaimType(id) {
      try {
        this.$vs.loading();
        const res = await claimTypeRepository.show(id);
        if (!res.status) {
          this.$vs.notify({
            title: res.message,
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        }
        this.claimType = new ClaimType(res.data);
      } catch (e) {
        this.$vs.notify({
          title: "損種(必要情報)テンプレート取得に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async setClaimItems() {
      try {
        this.$vs.loading();
        const res = await claimItemRepository.fetch({
          size: 9999,
        });
        if (!res.status) {
          this.$vs.notify({
            title: res.message,
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        }
        this.claimItems = res.data.claim_items.map(
          claimItem => new ClaimItem(claimItem)
        );
      } catch (e) {
        this.$vs.notify({
          title: "必要情報の取得に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    this.setUp();
  },
  mounted() {},
  updated() {},
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#claim-template-new {
  color: #757575;
  font-size: 18px;
  .list-controller {
    display: flex;
    margin-bottom: 20px;
    .filter-area {
      flex-grow: 1;
      display: flex;
      flex-wrap: wrap;
      .filter-input {
        margin-right: 8px;
        margin-bottom: 8px;
      }
    }
  }
  .right-widget-area {
    padding-left: 20px;
    max-width: 240px;
    font-size: 14px;
  }
  .list-message-label {
    margin: 10px;
  }
}
</style>
